import React from "react";

const Notifications = ({ data }) => {
  return (
    <div className="notifications-container">
      {!data.length ? (
        <div className="no-notification">
          <p>No Notifications at this Moment</p>
        </div>
      ) : (
        <div>notification card</div>
      )}
    </div>
  );
};

export default Notifications;
